import $ from 'jquery';
import pageScripts from './pages';
import { polyfill } from 'es6-promise';
import 'what-input';

polyfill();

//Node modules
require('./components/object-fit-images');
require('slick-carousel/slick/slick');

$( document ).ready( function () {
	//Require all components here.
	require( './components/foundation' );
	require( './components/open-side-nav' );
	require( './components/open-search-form' );
	require( './components/header-slider' );
	require( './components/content-slider' );
	require( './components/contact-form' );
	require( './components/selectable-content' );

	document.body.className.replace( /-/g, '_' ).split( /\s+/ ).forEach( cls => {
		pageScripts[ cls ] && pageScripts[ cls ]();
	} );
} );
